export { default } from './StaticTextInput';
